import StoreInsightContractWorkflowCommonLoader from '../libraries/store-insight-contract-workflow-common-loader'

export default {

  edit() {
    StoreInsightContractWorkflowCommonLoader()
  }
}
